import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import * as JSTool from '../store/JSTool';
import { useNavigate } from "react-router-dom";
import { settingActions, settingObj } from '../store/SettingSlice';
import Footer from '../view/Footer';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, EffectCoverflow } from 'swiper/modules';


export default function Page3(props) {

    const [swp, setSwp] = React.useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);
    const [currentIndex, setCurrentIndex] = React.useState(0);

    const [ary, setAry] = React.useState([
        "feature/f_1.png", "feature/f_2.png", "feature/f_3.png", "feature/f_4.png", "feature/f_5.png",

    ]);

    React.useEffect(() => {

    }, []);

    return (
        <Stack sx={{
            width: 1,
            height: settingData.height,
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            backgroundImage: `url(${JSTool.getImgPath('bg-4.jpg')})`,
            backgroundSize: '100% 100%',
        }}>

            {/* PC */}
            {!settingData.isMobile && <Swiper
                style={{
                    width: '840rem',
                    paddingLeft: '250rem',
                    paddingRight: '250rem',
                    marginBottom: '30rem',
                }}
                loop={true}
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                slideToClickedSlide={true}
                slidesPerView={'auto'}

                coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 600,
                    modifier: 1,
                    slideShadows: true,
                }}
                autoplay={{
                    delay: 3000, // 每隔 3 秒切换
                    disableOnInteraction: false, // 用户交互后仍继续自动播放
                }}
                onSwiper={(swiper) => {
                    setSwp(swiper);
                }}
                onSlideChangeTransitionEnd={(sp) => {
                    setCurrentIndex(sp.realIndex);
                }}
                modules={[Autoplay, EffectCoverflow]} >

                {ary.map((item, index) => {
                    return <SwiperSlide key={index}> <SwiperItem item={item} currentIndex={currentIndex} index={index} /> </SwiperSlide>
                })}
            </Swiper>}

            {/* Mobile */}
            {settingData.isMobile && <Swiper
                style={{
                    width: '100%',
                    marginBottom: '80rem',
                }}
                loop={true}
                grabCursor={true}
                centeredSlides={true}
                slideToClickedSlide={true}
                slidesPerView={'auto'}

                autoplay={{
                    delay: 3000, // 每隔 3 秒切换
                    disableOnInteraction: false, // 用户交互后仍继续自动播放
                }}
                onSwiper={(swiper) => {
                    setSwp(swiper);
                }}
                onSlideChangeTransitionEnd={(sp) => {
                    setCurrentIndex(sp.realIndex);
                }}
                modules={[Autoplay]} >

                {ary.map((item, index) => {
                    return <SwiperSlide key={index}> <SwiperItem item={item} currentIndex={currentIndex} index={index} /> </SwiperSlide>
                })}
            </Swiper>}

            <Footer />
        </Stack>
    );
}

function SwiperItem(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            width: settingData.isMobile ? 1 : '900rem',
            alignSelf: 'center',
            justifyContent: 'center',
            flexDirection: 'row'
        }}>

            <Box
                component={'img'}
                src={JSTool.getImgPath(props.item)}
                sx={{
                    width: settingData.isMobile ? 0.95 : 1,
                    borderRadius: '10rem',
                }}
            />

        </Stack>

    );
}